module.exports = __webpack_public_path__ + "static/media/receta-08.9199485d.png";